import { useState, useCallback } from 'react';
import { getUsedInventory } from '../services/usedInventoryService';

function dedupeKey(raw) {
  return `${raw.categoryCd}|${raw.subCategoryCd}|${raw.locationNbr}`;
}

function titleCase(str) {
  return str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase());
}

function dedupeInventory(rawItems, storeMap) {
  const keyOrder = [];
  const groups = new Map();

  rawItems.forEach((raw) => {
    const key = dedupeKey(raw);
    if (!groups.has(key)) {
      keyOrder.push(key);
      groups.set(key, []);
    }
    groups.get(key).push(raw);
  });

  const result = keyOrder
    .map((key) => {
      const group = groups.get(key);
      const rep = group[0];
      const desc = rep.description?.trim();
      const title = titleCase(desc);

      return {
        CategoryCd: rep.categoryCd,
        SubCategoryCd: rep.subCategoryCd,
        StrNbr: rep.locationNbr,
        SuggRetailPrice: rep.suggestedAmt,
        ManufacturerName: rep.manufacturerModelId,
        SubCategoryDesc: title,
        Count: group.length,
        StoreData: storeMap?.get(rep.locationNbr),
        title,
        rawUnits: group
      };
    })
    .filter((item) => item.title);

  return result;
}

export function useUsedProductInventory() {
  const [state, setState] = useState({
    inventory: [],
    loading: false,
    error: null
  });

  const fetchInventory = useCallback(async (storeNumbers, storeMap) => {
    setState((prev) => ({ ...prev, loading: true, error: null }));
    try {
      const data = await getUsedInventory(storeNumbers);
      const rawItems = Array.isArray(data) ? data : [];
      const mapped = dedupeInventory(rawItems, storeMap);
      setState({ inventory: mapped, loading: false, error: null });
    } catch (err) {
      setState((prev) => ({
        ...prev,
        loading: false,
        error: err instanceof Error ? err.message : 'Failed to load inventory'
      }));
    }
  }, []);

  return { ...state, fetchInventory };
}
